export default function () {
  /* 表格列头 */
  return [
    // { label: "序号", type: "index", width: 80 },
    { label: "序号", prop: "index", width: 80 },
    { label: "订单状态", prop: "status", slots: "status" },
    // { label: "订单类型", prop: "type", slots: "type", width: 100 },
    { label: "订单编号", prop: "orderNumber", width: 200 },
    { label: "子订单编号", prop: "sub_orderNumber", slots: "sub_orderNumber", width: 200 },
    { label: "物流单号", prop: "logisticsNumber", slots: "logisticsNumber", width: 230 },
    { label: "商品编码", prop: "productCode", slots: "productCode", width: 200 },
    { label: "商品名称", prop: "productName", slots: "productName", width: 200 },
    { label: "下单数量", prop: "num", slots: "num", width: 80 },
    { label: "价格", prop: "price", slots: "price", width: 100 },
    { label: "订单总额", prop: "cost", width: 100 },
    { label: "订单支付总额", prop: "realityCost", width: 120 },
    {
      label: "订单创建时间",
      prop: "createTime",
      width: 180,
    },
    // { label: "openid", prop: "openid" },
    {
      label: "支付方式",
      prop: "payStyle",
      slots: "payStyle",
      width: 140,
    },
    {
      label: "微信交易流水号",
      prop: "transaction_id",
      width: 180,
    },
    // { label: "姓名", prop: "name", width: 100 },
    // { label: "手机号", prop: "phone", width: 130 },
    // { label: "订单金额", prop: "cost", width: 100 },
    // { label: "实际支付金额", prop: "realityCost", width: 120 },
    // { label: "订单明细", prop: "detail", slots: "detail", width: 500 },
    // { label: "订单备注", prop: "odescribe" },
    // {
    //   label: "企业主账户ID",
    //   prop: "admin_id",
    //   width: 180,
    //   slots: "admin_id",
    // },
    // {
    //   label: "下单会员账户ID",
    //   prop: "admin_pay_id",
    //   width: 180,
    //   slots: "admin_pay_id",
    // },
    // {
    //   label: "客户api下单关联id",
    //   prop: "relationOrderId",
    //   width: 180,
    // },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
